import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { EnviarCorreoService } from "../../servicios/enviar-correo.service";
import { ActivatedRoute } from "@angular/router";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { EnviarCorreo } from "../../entidades/entidades";


@Component({
  selector: "app-enviar-correo",
  templateUrl: "./enviar-correo.component.html",
  styleUrls: ["./enviar-correo.component.css"]
})

export class EnviarCorreoComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  enviarCorreoForm: FormGroup;
  @Input("enviarCorreo") enviarCorreo: EnviarCorreo;
  @Output("enviarCorreoOutput") enviarCorreoOutput: EventEmitter<EnviarCorreo>;

  public progressBar = false ;
  showBar() {
    this.progressBar = true;
  }


  constructor(
    private formBuilder: FormBuilder,
    private enviarCorreoService: EnviarCorreoService,
    private route: ActivatedRoute
  ) {
    this.enviarCorreoOutput = new EventEmitter()
  }

  ngOnInit() {
    this.enviarCorreoForm = this.formBuilder.group({
      _idFacturas : [undefined ,[Validators.pattern(/^[0-9]+\.?[0-9]*$/)] ],
      correo : [undefined  ],
      correocopia : [undefined  ],
    });
    if (this.enviarCorreo) this.enviarCorreoForm.patchValue(this.enviarCorreo);
  }

  //====================================================
  //Función de muestra.
  //====================================================
  async EnviarCorreo() {
    try {
      if (this.enviarCorreoForm.invalid) {
        throw new Error("No paso las validaciones.");
      }
      
      // console.log('Esto llega del hijo ',this.enviarCorreo);
      this.showBar();
      let datosEnviarCorreo = new EnviarCorreo();
      datosEnviarCorreo = this.enviarCorreoForm.value;
      datosEnviarCorreo.idFactura = this.enviarCorreo.idFactura;
      datosEnviarCorreo.enviosFactura = true;
      // console.log('ESTO ENVIAMOAS AL API', datosEnviarCorreo);
      this.addEnviarCorreo(datosEnviarCorreo );
     // this.enviarCorreoOutput.emit(this.enviarCorreo);
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por guardarEnviarCorreo");
    }
  }

  //====================================================
  //Metodos para obtener datos del servicio
  //====================================================
  async addEnviarCorreo(enviarCorreo) {
    try {
      // console.log('ESTO SE ENVIA !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!',enviarCorreo);
      const datoretorno = await this.enviarCorreoService
        .add(enviarCorreo)
        .toPromise();
      console.log(datoretorno);
      let respuesta = datoretorno;
      this.progressBar = false;
      if (respuesta.toString() == "OK") { 
        this.muestraMensaje.notification("Envió exitoso", "top", "center");
      }
      else {
        throw new Error(respuesta.toString());
      }
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por addEnviarCorreo");
    }
  }
}